import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateRange } from '../../models/date-range';

@Component({
  selector: 'lib-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleSwitchComponent),
      multi: true
    }
  ],
  standalone: false
})
export class ToggleSwitchComponent implements OnInit, ControlValueAccessor {
  @Input()
  public id: string;

  @Input()
  public label: string;

  public value: boolean;

  public isDisabled: boolean;

  public onChange = (_: boolean) => {};
  public onTouched = () => {};

  writeValue(obj: boolean): void {
    if (obj != this.value) {
      this.value = obj;
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
  ngOnInit(): void {
    if (this.value == null) this.value = false;
  }

  valueChanged(val) {
    if (val != null && val != this.value) {
      this.value = val;
      this.onChange(val);
    } else if (val == null) {
      this.value = false;
    }
  }
}
